import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function deleteTravelSurcharge(travelId: string) {
  return getSMPBackendAPIAdmin().settingsControllerDeleteTravelSurchargeV1(travelId);
}

export function useDeleteTravelSurcharge() {
  return useMutation({ mutationFn: deleteTravelSurcharge });
}
